import apiClient from './apiClient';

export const getRolesByRoleGroupId = async (id) => {
  const response = await apiClient.post('/role/GetRolesByGroupId', null, {
    params: { id },
  });

  return response.data.Data.Items; // { Assigned: [], Unassigned: [] }
};

export const assignRolesToGroup = async (groupId, roleIds) => {
  const response = await apiClient.post('/role/AddRoleToRoleGroup', {
    RoleGroupId: groupId,
    RoleIds: roleIds,
  });
  return response.data;
};

export const addRoleToRoleGroup = async (dto) => {
  const response = await apiClient.post('/role/AddRoleToRoleGroup', dto);
  return response.data;
};

export const deleteRoleFromRoleGroup = async (dto) => {
  const response = await apiClient.post('/role/DeleteRoleToRoleGroup', dto);
  return response.data;
};
